import React, {useEffect, useState} from 'react';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col';
import CkEditor from '../ckeditor';
import 'react-dropzone-uploader/dist/styles.css'
import CustomDropzone from "../customDropzone";

function Template4(props) {
    const {values,index,setFieldValue,name,moduleErrors,moduleTouched,handleBlur} = props

    return (
        <div className="templates-wrap">
            <Row>
                <Col md={12}>
                    <div className="image-min-size">
                        <CustomDropzone  moduleErrors={moduleErrors} moduleTouched={moduleTouched} name={`modules.${index}.image`} setFieldValue={setFieldValue} values={values} index={index} handleBlur={handleBlur}/>
                    </div>
                    {moduleErrors?.image && moduleTouched?.image &&
                    <span className={`form-error text-danger`} style={{display:'block'}}>{moduleErrors?.image}</span>}
                </Col>
                <Col md={12}><CkEditor moduleErrors={moduleErrors} moduleTouched={moduleTouched} name={`modules.${index}.contents`} setFieldValue={setFieldValue} values={values} index={index} handleBlur={handleBlur}/></Col>
            </Row>

        </div>
    )
};
export default Template4;
